/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timestamp: NonNullable<unknown> }} Coinvestments_Tracking_Lastupdated2Inputs */

const en_coinvestments_tracking_lastupdated2 = /** @type {(inputs: Coinvestments_Tracking_Lastupdated2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last updated: ${i?.timestamp}`)
};

/**
* | output |
* | --- |
* | "Last updated: {timestamp}" |
*
* @param {Coinvestments_Tracking_Lastupdated2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_lastupdated2 = /** @type {((inputs: Coinvestments_Tracking_Lastupdated2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Lastupdated2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_lastupdated2(inputs)
});
export { coinvestments_tracking_lastupdated2 as "coInvestments_tracking_lastUpdated" }